import Lara from "@/presets/lara";

export const accountApplicationPresets = {
  ...Lara,
  checkbox: {
    ...Lara.checkbox,
    box: (args) => {
      return { class: [...Lara.checkbox.box(args).class, "rounded-md"] };
    },
    root: { class: [...Lara.checkbox.root.class] },
  },
  chip: {
    ...Lara.chip,
    container: (args) => ({
      class: [...Lara.chip.container(args).class],
    }),
    root: {
      class: ["border-none", "!rounded-full", "h-6", ...Lara.chip.root.class],
    },
  },
};
